import { Compass, Loader2, X } from 'lucide-react';

import { useTour } from './TourProvider';
import { useTourDismissed, useDismissTour } from '@/hooks/useTour';

/**
 * Persistent "Want a product tour?" bar shown across the app until the user
 * permanently dismisses it ("Got it, don't show again" → tour_dismissed_at).
 * Rendered by AppShell on customer-context pages (not /admin).
 */
export function TourBar() {
  const { startTour } = useTour();
  const { data: dismissed, isLoading } = useTourDismissed();
  const dismiss = useDismissTour();

  if (isLoading || dismissed) return null;

  return (
    <div className="flex items-center gap-3 border-b border-brix-primary/20 bg-brix-primary-tint/60 px-4 py-2 text-brix-ink md:px-6">
      <Compass size={17} className="shrink-0 text-brix-primary" aria-hidden />
      <p className="min-w-0 flex-1 text-sm leading-tight">
        <span className="font-semibold">New here?</span>{' '}
        <span className="hidden sm:inline">Take a quick tour of the portal.</span>
      </p>
      <button
        type="button"
        onClick={() => startTour()}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-brix-primary px-3 py-1.5 text-sm font-bold text-white transition-colors hover:bg-brix-primary-deep"
      >
        <Compass size={14} /> Take the tour
      </button>
      <button
        type="button"
        onClick={() => dismiss.mutate()}
        disabled={dismiss.isPending}
        title="Got it — don't show this again"
        className="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1.5 text-sm font-semibold text-brix-muted transition-colors hover:bg-brix-surface hover:text-brix-ink disabled:opacity-60"
      >
        {dismiss.isPending ? <Loader2 size={14} className="animate-spin" /> : <X size={14} />}
        <span className="hidden sm:inline">Don't show again</span>
      </button>
    </div>
  );
}
